export default "__VITE_ASSET__BTH_kmyw__"